import { ChatContext } from '@parcel2go/peacock-legacy-chat/dist/chat';
import React from 'react';
import { TrackingIssueMessage } from '../issues';
import { P2GLink } from '@parcel2go/peacock-legacy-core/dist/link';
interface ITrackingCollection {
  orderReference: number
  hasAddressIssue?: boolean,
  hasAttemptedCollection?: boolean,
  hasCancelled?: boolean,
  isOwner: boolean,
  loadChatContext: (profile: string) => Promise<ChatContext>,
  onChatStarted: () => void,
  onChatEnded: (start?: Date | null, end?: Date | null) => void
  headingVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

const TrackingCollection: React.FC<ITrackingCollection> = (props) => {

  const sharedProps = { orderReference: props.orderReference, showOptions: true, loadChatContext: props.loadChatContext, onChatStarted: props.onChatStarted, onChatEnded: props.onChatEnded }

  return (
    <React.Fragment>
      {props.hasCancelled &&
        <TrackingIssueMessage color="info" title="TRACKING.RESULT.ISSUE.CANCELLEDTITLE" message="TRACKING.RESULT.ISSUE.CANCELLED" {...sharedProps} headingVariant={props.headingVariant}/>
      }
      {!props.hasCancelled && props.hasAddressIssue &&
        <TrackingIssueMessage color="info" title="TRACKING.RESULT.COLLECTION.ADDRESSISSUETITLE" message="TRACKING.RESULT.COLLECTION.ADDRESSISSUE" headingVariant={props.headingVariant} components={[<P2GLink href="/service-centre/select?caseType=EditAddress" />]} {...sharedProps} >
          TRACKING.RESULT.COLLECTION.ADDRESSISSUETITLE
        </TrackingIssueMessage>
      }
      
      {!props.hasCancelled && props.hasAttemptedCollection &&
        <TrackingIssueMessage color="info" title="TRACKING.RESULT.COLLECTION.ATTEMPTEDTITLE" message="TRACKING.RESULT.COLLECTION.ATTEMPTED" headingVariant={props.headingVariant} components={[<P2GLink href="/help-centre/rebook" />]} {...sharedProps}>
          TRACKING.RESULT.COLLECTION.ATTEMPTEDTITLE
        </TrackingIssueMessage>
      }

      {!props.hasCancelled && !props.hasAttemptedCollection && !props.hasAddressIssue &&
        <TrackingIssueMessage color="info" title="TRACKING.RESULT.COLLECTION.WAITINGTITLE" message="TRACKING.RESULT.COLLECTION.WAITING" headingVariant={props.headingVariant} {...sharedProps} />
      }
    </React.Fragment>
  );
}

export default TrackingCollection;
